import { WidgetKind, type Report } from 'corso-admin-ui';
import { itemsOverTime, productTables } from '../claimItems';

export const products = {
  key: 'products',
  label: 'Products',
  dataset: 'claimItems',
  timeFields: ['createdOn', 'finalizedOn'],
  widgets: [
    { kind: WidgetKind.kpi, title: 'Warranty items', metric: 'items' },
    itemsOverTime,
    {
      kind: WidgetKind.table,
      title: 'Product types',
      dimensions: ['productType'],
      metrics: ['items', 'itemValue'],
    },
    ...productTables,
  ],
} as const satisfies Report;
